<template>
  <div class="backgr" v-if="!isMobile">
    <img src="../assets/images/logo.svg" class="logo-desktop fade-in">
    <FormLogin v-if="!isMobile" />
  </div>
  <div class="backgr-mobile" v-else>
    <img src="../assets/images/logo.svg" class="logo-mobile fade-in">
    <!-- Added floating animation to robot -->
    <transition name="robot-fade">
      <img v-if="robotShow" src="../assets/images/robot_mobile.svg" class="robot-image floating">
    </transition>
    <FormLoginMobile @removeRobot="robotShow = false" />
  </div>
</template>
<script>
import FormLogin from '@/components/auth/byPhone/FormLogin.vue'
import FormLoginMobile from '@/components/auth/byPhone/FormLoginMobile.vue'
import Auth from '@/services/auth.service.js'

export default {
  components: {
    FormLogin,
    FormLoginMobile
  },
  data: () => ({
    isMobile: false,
    email: "",
    password: "",
    progressShow: false,
    snackbar: false,
    snackbarColorBt: "green",
    snacbarText: "",
    robotShow: true,
  }),
  mounted() {
    document.title = 'כניסה | clickcallmobile'
    let auth = Auth.checkAuth();
    if (auth) {
      this.$router.replace({ name: "callHistory" })
    }
    if (window.innerWidth <= 1000) {
      this.isMobile = true;
    } else {
      this.isMobile = false;
    }
  },
  beforeRouteLeave(to, from, next) {
    this.robotShow = true;
    next();
  },
}
</script>
<style scoped>
.backgr {
  display: flex;
  flex-direction: column;
  width: 100vw;
  height: 100vh;
  background-image: url('../assets/images/login_back.svg');
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  align-items: center;
  padding: 15px;
  box-sizing: border-box;
  transform: translateZ(0);
  animation: pages_colorIn__r4Ogf 2.5s ease-out;
}

.backgr-mobile {
  display: flex;
  flex-direction: column;
  width: 100vw;
  height: 100vh;
  background-image: url('../assets/images/login_back_mobile.svg');
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  align-items: center;
  padding: 15px;
  box-sizing: border-box;
  transform: translateZ(0);
  animation: pages_colorIn__r4Ogf 2.5s ease-out;
  overflow: hidden;
}

/* Added logo animations and responsive positioning */
.logo-desktop {
  width: 15%;
  min-width: 120px;
  max-width: 200px;
  position: absolute;
  left: 7%;
  top: 7%;
  filter: drop-shadow(0 4px 6px rgba(0, 0, 0, 0.1));
  transition: transform 0.3s ease;
}

.logo-desktop:hover {
  transform: scale(1.05);
}

.logo-mobile {
  width: 30%;
  min-width: 100px;
  max-width: 150px;
  position: absolute;
  left: 7%;
  top: 7%;
  filter: drop-shadow(0 4px 6px rgba(0, 0, 0, 0.1));
  transition: transform 0.3s ease;
}

/* Added floating animation for robot */
.robot-image {
  position: absolute;
  right: 0%;
  top: 2%;
  bottom: 60%;
  max-height: 50%;
  max-width: 45%;
  object-fit: contain;
  filter: drop-shadow(0 8px 16px rgba(0, 0, 0, 0.15));
}

.floating {
  animation: float 3s ease-in-out infinite;
}

@keyframes float {

  0%,
  100% {
    transform: translateY(0px);
  }

  50% {
    transform: translateY(-20px);
  }
}

/* Added fade-in animation */
.fade-in {
  animation: fadeIn 1s ease-in;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Added robot transition effects */
.robot-fade-enter-active {
  animation: robotEnter 0.8s ease-out;
}

.robot-fade-leave-active {
  animation: robotLeave 0.5s ease-in;
}

@keyframes robotEnter {
  from {
    opacity: 0;
    transform: translateX(100px) rotate(10deg);
  }

  to {
    opacity: 1;
    transform: translateX(0) rotate(0deg);
  }
}

@keyframes robotLeave {
  from {
    opacity: 1;
    transform: translateX(0) scale(1);
  }

  to {
    opacity: 0;
    transform: translateX(100px) scale(0.8);
  }
}

@keyframes pages_colorIn__r4Ogf {
  0% {
    filter: grayscale(1);
  }

  100% {
    filter: grayscale(0);
  }
}

/* Added responsive breakpoints */
@media (max-width: 600px) {
  .logo-mobile {
    width: 35%;
    top: 5%;
    left: 5%;
  }

  .robot-image {
    max-height: 40%;
    top: 5%;
  }
}

@media (min-width: 1000px) and (max-width: 1400px) {
  .logo-desktop {
    width: 12%;
  }
}
</style>
